var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { useHistory } from "react-router";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useOkapiKy } from "@folio/stripes/core";
import { PublisherLegalFormEnum, PublisherStatusEnum, } from "../types/Api";
import { createNewPublisherSchema, } from "../utils/validationUtils";
import { fetchRegions } from "../api/regionService";
import { createPublisher, checkDuplicateCompanyNumber, } from "../api/publisherService";
import { hasHttpResponse } from "../utils/apiUtils";
import { extractServerErrorMessage } from "../utils/errorHandler";
var ADDRESS_PLACEHOLDER = "-";
export var useNewPublisherForm = function (_a) {
    var onPublisherCreated = _a.onPublisherCreated, _b = _a.inModal, inModal = _b === void 0 ? false : _b;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var queryClient = useQueryClient();
    var newPublisherSchema = createNewPublisherSchema(formatMessage);
    var publisherForm = useForm({
        resolver: zodResolver(newPublisherSchema),
        shouldFocusError: false,
        defaultValues: {
            registrationAgency: undefined,
            companyNumber: "",
            name: "",
            nameSuffix: "",
            legalForm: PublisherLegalFormEnum.LEGAL,
            taxNumber: "",
            birthDate: "",
            status: PublisherStatusEnum.REQUEST,
            mainAddress: {
                street: "",
                postalCode: "",
                municipality: "",
                regionId: "",
            },
            contacts: [],
        },
        mode: "onBlur",
    });
    var setValue = publisherForm.setValue, getValues = publisherForm.getValues, trigger = publisherForm.trigger, reset = publisherForm.reset;
    var _c = useState(null), icoError = _c[0], setIcoError = _c[1];
    var _d = useState(null), errorMessage = _d[0], setErrorMessage = _d[1];
    var regionsData = useQuery(["regions"], function () {
        return fetchRegions(ky);
    }).data;
    var createPublisherMutation = useMutation(function (publisherData) { return createPublisher(ky, publisherData); }, {
        onSuccess: function (createdPublisher) {
            queryClient.invalidateQueries(["publishers"]);
            if (onPublisherCreated) {
                onPublisherCreated(createdPublisher);
            }
            else if (!inModal) {
                history.goBack();
            }
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (hasHttpResponse(error) && error.response.status === 409) {
                            setErrorMessage(formatMessage({
                                id: "ui-br-legaldeposits.publishers.error.duplicateCompanyNumber",
                            }));
                            return [2 /*return*/];
                        }
                        _a = setErrorMessage;
                        return [4 /*yield*/, extractServerErrorMessage(error, formatMessage, formatMessage({
                                id: "ui-br-legaldeposits.error.publisher.create",
                            }))];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var submitPublisher = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var submissionData;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            submissionData = __assign(__assign({}, data), { name: (_a = data.name) !== null && _a !== void 0 ? _a : "", legalForm: (_b = data.legalForm) !== null && _b !== void 0 ? _b : PublisherLegalFormEnum.LEGAL, status: (_c = data.status) !== null && _c !== void 0 ? _c : PublisherStatusEnum.REQUEST, mainAddress: __assign(__assign({}, ((_d = data.mainAddress) !== null && _d !== void 0 ? _d : {
                    addressCode: "",
                    street: "",
                    postalCode: "",
                    municipality: "",
                    regionId: "",
                    region: { id: "", name: "" },
                })), { street: ((_e = data.mainAddress) === null || _e === void 0 ? void 0 : _e.street) || ADDRESS_PLACEHOLDER, postalCode: ((_f = data.mainAddress) === null || _f === void 0 ? void 0 : _f.postalCode) || ADDRESS_PLACEHOLDER, municipality: ((_g = data.mainAddress) === null || _g === void 0 ? void 0 : _g.municipality) || ADDRESS_PLACEHOLDER }), registrationAgency: data.registrationAgency, contacts: (_h = data === null || data === void 0 ? void 0 : data.contacts) === null || _h === void 0 ? void 0 : _h.filter(function (contact) { return contact.value !== ""; }).map(function (contact) {
                    var _a, _b;
                    return (__assign(__assign({}, contact), { id: (_a = contact.id) !== null && _a !== void 0 ? _a : undefined, info: (_b = contact.info) !== null && _b !== void 0 ? _b : undefined }));
                }) });
            createPublisherMutation.mutate(submissionData);
            return [2 /*return*/];
        });
    }); };
    var checkDuplicateMutation = useMutation(function (companyNumber) {
        return checkDuplicateCompanyNumber(ky, companyNumber);
    });
    var duplicityCheck = checkDuplicateMutation.data;
    var blockingPublisher = (duplicityCheck === null || duplicityCheck === void 0 ? void 0 : duplicityCheck.isDuplicate) ? duplicityCheck : null;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIcoError(null);
                    setErrorMessage(null);
                    checkDuplicateMutation.reset();
                    if (!(data.companyNumber && data.companyNumber.trim() !== "")) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, checkDuplicateMutation.mutateAsync(data.companyNumber)];
                case 2:
                    result = _b.sent();
                    if (result.isDuplicate) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    _a = setErrorMessage;
                    return [4 /*yield*/, extractServerErrorMessage(error_1, formatMessage, formatMessage({
                            id: "ui-br-legaldeposits.publishers.error.duplicityCheck",
                        }))];
                case 4:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
                case 5: return [4 /*yield*/, submitPublisher(data)];
                case 6:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var dismissBlockingPublisher = function () {
        checkDuplicateMutation.reset();
    };
    var selectBlockingPublisher = function () {
        var _a;
        var publisherId = blockingPublisher === null || blockingPublisher === void 0 ? void 0 : blockingPublisher.publisherId;
        if (!publisherId || !onPublisherCreated)
            return;
        var publisherName = (_a = blockingPublisher === null || blockingPublisher === void 0 ? void 0 : blockingPublisher.publisherName) !== null && _a !== void 0 ? _a : undefined;
        checkDuplicateMutation.reset();
        // onPublisherCreated is the form's "publisher chosen" channel, so an already
        // existing publisher travels back to the verification form the same way.
        onPublisherCreated({ id: publisherId, name: publisherName });
    };
    var dismissError = function () {
        setErrorMessage(null);
    };
    var icoLoadedCallback = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        setValue("name", (_a = data === null || data === void 0 ? void 0 : data.name) !== null && _a !== void 0 ? _a : "", { shouldValidate: true });
        setValue("nameSuffix", (_b = data === null || data === void 0 ? void 0 : data.nameSuffix) !== null && _b !== void 0 ? _b : "");
        setValue("legalForm", (_c = data === null || data === void 0 ? void 0 : data.legalForm) !== null && _c !== void 0 ? _c : getValues("legalForm"), {
            shouldValidate: true,
        });
        setValue("taxNumber", (_d = data === null || data === void 0 ? void 0 : data.taxNumber) !== null && _d !== void 0 ? _d : getValues("taxNumber"), {
            shouldValidate: true,
        });
        if (data === null || data === void 0 ? void 0 : data.mainAddress) {
            setValue("mainAddress.street", ((_e = data.mainAddress) === null || _e === void 0 ? void 0 : _e.street) || "");
            setValue("mainAddress.postalCode", ((_f = data.mainAddress) === null || _f === void 0 ? void 0 : _f.postalCode) || "");
            setValue("mainAddress.municipality", ((_g = data.mainAddress) === null || _g === void 0 ? void 0 : _g.municipality) || "");
            setValue("mainAddress.regionId", ((_j = (_h = data.mainAddress) === null || _h === void 0 ? void 0 : _h.region) === null || _j === void 0 ? void 0 : _j.id) || ((_k = data.mainAddress) === null || _k === void 0 ? void 0 : _k.regionId) || "");
            setValue("mainAddress.region", {
                id: (_o = (_m = (_l = data.mainAddress) === null || _l === void 0 ? void 0 : _l.region) === null || _m === void 0 ? void 0 : _m.id) !== null && _o !== void 0 ? _o : "",
                name: (_r = (_q = (_p = data.mainAddress) === null || _p === void 0 ? void 0 : _p.region) === null || _q === void 0 ? void 0 : _q.name) !== null && _r !== void 0 ? _r : "",
            });
        }
        setValue("contacts", (_u = (_t = (_s = data === null || data === void 0 ? void 0 : data.contacts) === null || _s === void 0 ? void 0 : _s.filter(function (c) { return c.value && c.type; }).map(function (c) {
            var _a, _b;
            return ({
                id: (_a = c.id) !== null && _a !== void 0 ? _a : undefined,
                type: c.type,
                value: c.value,
                info: (_b = c.info) !== null && _b !== void 0 ? _b : undefined,
                isPrimary: c.isPrimary,
            });
        })) !== null && _t !== void 0 ? _t : getValues("contacts")) !== null && _u !== void 0 ? _u : [], {
            shouldValidate: true,
        });
    };
    return {
        publisherForm: publisherForm,
        regionsData: regionsData,
        icoError: icoError,
        setIcoError: setIcoError,
        trigger: trigger,
        onSubmit: onSubmit,
        blockingPublisher: blockingPublisher,
        canSelectBlockingPublisher: !!onPublisherCreated,
        dismissBlockingPublisher: dismissBlockingPublisher,
        selectBlockingPublisher: selectBlockingPublisher,
        resetForm: reset,
        errorMessage: errorMessage,
        dismissError: dismissError,
        icoLoadedCallback: icoLoadedCallback,
    };
};
